import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ahknhye3gz: FaireBrandEntity = {
  token: "b_ahknhye3gz",
  type: "brand",
  name: "Dosso Beauty",
  avatarUrl:
    "https://cdn.faire.com/fastly/97d22ce343d0dd380591b4785c433df9325156bd999ecbc2716a364fb304f1b3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/065ca6e279d160f4aaea215311b50574ce6575cbcc6aab703823e0f088b99bc1.png",
  logoUrl:
    "https://cdn.faire.com/fastly/97d22ce343d0dd380591b4785c433df9325156bd999ecbc2716a364fb304f1b3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/065ca6e279d160f4aaea215311b50574ce6575cbcc6aab703823e0f088b99bc1.png",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 13,
  isTopShop: true,
  isInsider: true,
  description:
    "Dosso Beauty is a Black-Owned e-commerce organic beauty supply retailer and wholesaler that provides people of color access to clean beauty products that are created for people of color and curated by people of color. We are home of the #1 Pre-stretched Hypoallergenic Braiding Hair and hair extensions.\n\nWe have over 160 products that fall within the following categories: hair extensions, hair products, skin care and eco-friendly beauty tools. Each of these products were intentionally curated with organic, cruelty-free and eco-friendly materials that are affordable and also best serve people of color who are sensitive to harmful chemicals.\n\nOur CEO, Kadidja Dosso, was born and raised in West Philadelphia. She is a proud Alumna of the illustrious Hampton University. From a young age she knew that her purpose in life was to make people feel great about themselves.\n\nMost recently, we were awarded Pharrell William's Black Ambition HBCU Grand Prize to invest in our mission to build an organic beauty supply empire. In addition, we've been featured in several publications such as Vogue, GQ, NY Magazine, Madame Noire, Hello Beautiful, 21 N1nety, Yahoo Life, NY Magazine, Daily Press and many more!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:16.345Z",
    importedBy: "entity-db-cli",
  },
};
